import SideNavigation from './SideNavigation.component';

export default SideNavigation;